import { Model } from '@vuex-orm/core'
import LtmHasRoomtypeHasRoomltm from '@models/helpers/LtmHasRoomtypeHasRoomltm'
import RoomltmsHasOperationmode from '@models/helpers/RoomltmsHasOperationmode'

export default class Roomltm extends Model{
  static entity = 'roomltms'
  static fields () {
    return {
      id: this.number(null),
      label: this.string(null).nullable(),

      ltmHasRoomtypeHasRoomltms: this.hasMany(LtmHasRoomtypeHasRoomltm, 'roomltms_id'),
      roomltmsHasOperationmodes: this.hasMany(RoomltmsHasOperationmode, 'roomltms_id')
    }
  }
}
  